export default __webpack_public_path__ + "static/media/CarImages.SonetSmall.39287b7f.jpg";